// Mirrors the backend enum (app/Enums/AccessTier.php), lowest to highest.
//
// Only locked, free and plus are reachable today. The rest are here so the
// order is right from the start, because that is the part that is painful to
// change later.
export enum accessTier {
  LOCKED = 'locked',
  FREE = 'free',
  PLUS = 'plus',
  CLUB = 'club',
  ENTERPRISE = 'enterprise',
}
